"use client";
import { APP_BAR_CHECK_COOKIE } from "@/utils/constants";
import Image from "next/image";
import { useEffect, useState } from "react";
import Icon from "./icon";

const AppBar = () => {
  const [deviceModel, setDeviceModel] = useState<"ios" | "android" | null>(
    null,
  );
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    const w = window as any;
    const userAgent = w.navigator.userAgent || w.navigator.vendor || w.opera;

    if (/android/i.test(userAgent)) {
      setDeviceModel("android");
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !w.MSStream) {
      setDeviceModel("ios");
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    const cookieExpirationDays = 365;
    document.cookie = `${APP_BAR_CHECK_COOKIE}=true; path=/; max-age=${
      cookieExpirationDays * 24 * 60 * 60
    }`; // Cookie expires in 1 year
  };

  if (!isVisible) return null;

  return (
    <>
      {deviceModel === "ios" && (
        <div
          id="app-bar"
          className="app-store bg-sand-500 p-3 max-h-[100px] flex justify-between items-center"
        >
          <div className="flex gap-2 items-center">
            <button
              className="btn-icon h-6 w-6"
              onClick={handleClose}
              aria-label="Stäng meddelande om att ladda ner app"
            >
              <Icon.Close className="fill-gray-900 h-2" />
            </button>
            <Image
              src="/images/app-icon.svg"
              alt="EFN App för iOS"
              width={45}
              height={45}
              className="object-cover rounded-xl h-auto w-[45px]"
            />
            <div>
              <p className="font-bold text-sm ">Läs i appen - allt gratis</p>
              <p className="text-sm">App store</p>
            </div>
          </div>
          <a
            className="btn btn-primary"
            href="https://apps.apple.com/se/app/efn/id6738092534?itscg=30200&itsct=apps_box_link&mttnsubad=6738092534"
          >
            Ladda hem
          </a>
        </div>
      )}

      {deviceModel === "android" && (
        <div
          id="app-bar"
          className="play-store bg-sand-500 p-3 max-h-[100px] flex justify-between items-center"
        >
          <div className="flex gap-2 items-center">
            <button
              className="btn-icon h-6 w-6"
              onClick={handleClose}
              aria-label="Stäng meddelande om att ladda ner app"
            >
              <Icon.Close className="fill-gray-900 h-2" />
            </button>
            <Image
              src="/images/app-icon.svg"
              alt="EFN App för Andriod"
              width={45}
              height={45}
              className="object-cover rounded-xl h-auto w-[45px]"
            />
            <div>
              <p className="font-bold">EFN Ekonomikanalen</p>
              <p className="text-sm">Google Play</p>
            </div>
          </div>
          <a
            className="py-2 px-4 flex text-sm items-center justify-center bg-red-800 font-bold text-white-500 rounded-sm"
            href="https://play.google.com/store/apps/details?id=se.efn.app"
          >
            Ladda hem
          </a>
        </div>
      )}
    </>
  );
};

export default AppBar;
